import { getReportsQueryOptions } from '@/api/reports';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useQuery } from '@tanstack/react-query';

export const useReportsQuery = () => {
    const {
        dashboard: { id: dashboardId },
        project: { id: projectId },
    } = useDashboardGlobalContext();

    const {
        data: reports,
        isLoading,
        isFetching,
        isError,
        error,
    } = useQuery(
        getReportsQueryOptions({
            projectId,
            dashboardId,
        }),
    );

    return {
        reports,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
